import React, { useState, useEffect, useContext } from "react";
import {
  Typography, Paper, Box, Stack, Button, Grid, Skeleton, useMediaQuery, Tooltip, useTheme, Dialog, DialogActions, CardContent, CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  DialogContent, Avatar, DialogTitle, RadioGroup, FormControlLabel, Radio, Snackbar, Alert, Checkbox, Card, Badge, IconButton, Divider, Breadcrumbs, List, ListItem, tableCellClasses, Chip
} from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import parse from "html-react-parser";
import { styled } from "@mui/material/styles";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

import {
  BusinessCenterRounded, ChecklistRtlRounded, FlightRounded, SchoolRounded, WorkHistoryRounded, PhoneRounded, EmailRounded, ArrowRightOutlined, LocationCityOutlined, ManageAccountsRounded, AssignmentLateRounded, WorkspacePremiumRounded
} from "@mui/icons-material";
import { TiSocialLinkedin } from "react-icons/ti";
import { creteNotificationAction, getInterestedJobAction, updateInterestedJobAction, getCandidateDetailAction } from "../redux/action";
import { userSelector } from "../user-redux/selector";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import Key from "../../../src/clientVariables.json";
import axios from "axios";
import { candidateSelectedResumeAction } from "../redux/action";
import ResumePdfViewer from "../candidatesPage/ResumePdfViewer";
import { useResponsiveStyles } from "./responsiveStyles";
import { hideLoader } from "../actions/loadingActions";
import { useNavigate } from "react-router";
import { resumeBuilderSelector } from "../OptimiseResume/ResumeBuilderActions/selector";
import ResumeContext from "../OptimiseResume/Resumecontext";
import { resetResumeAction } from "../OptimiseResume/ResumeBuilderActions/actions";
import useAdvancedOptimise from "../AdvancedOptimiseResume/useAdvancedOptimise";
import AdvancedOptimiseAnalysingDialog from "../AdvancedOptimiseResume/AdvancedOptimiseAnalysingDialog";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const Jobdetailsview = ({ resumeId, activeJobSkills, resume, requiredSkills }) => {
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const { selectedJob, candidateDetails, jobDetails, primaryResumeDetails, candidateSelectedResume, selectedJobLoading } = useSelector(appSelector);
  const { isOpenInterested, currentSection } = useSelector(resumeBuilderSelector)

  const { user } = useSelector(userSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const contextObject = useContext(ResumeContext)
  const { runAdvancedOptimise, analysing: advancedAnalysing, error: advancedError, clearError: clearAdvancedError } = useAdvancedOptimise();
  const [loading, setLoading] = useState(true);
  const [interestedJobIds, setInterestedJobIds] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [resumeOption, setResumeOption] = useState("existing");
  const [toastOpen, setToastOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const theme = useTheme();
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops
  const [notInterestedJobIds, setNotInteretedJobIds] = useState([]);
  const [interested, setInterested] = useState();
  const [severity, setSeverity] = useState("success");
  const [dialogOpen1, setDialogOpen1] = useState(false);  // State to manage the dialog open/close
  const [jobForInterest, setJobForInterest] = useState(null);
  const [resumeDetails, setResumeDetails] = useState([]);
  const [projectDetails, setProjectDetails] = useState([]);
  const [resumes, setResumes] = useState();
  const [resumesLoading, setResumesLoading] = useState(true);
  const [resumeDetailsLoading, setResumeDetailsLoading] = useState(false);
  const [selectedResume, setSelectedResume] = useState(null);
  const styles = useResponsiveStyles();
  const [skillsOpen, setSkillsOpen] = useState(true);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [aiSkillsByResumeTitle, setAiSkillsByResumeTitle] = useState([]);
  const [aiDescriptionSkills, setAiDescriptionSkills] = useState([]);
  const [matchedSkillsList, setMatchedSkillsList] = useState([]);
  const [skillsInResume, setSkillsInResume] = useState([]);
  const [matchedSkillsOpen, setMatchedSkillsOpen] = useState(false);
  const [resumeFullDetails, setResumeFullDetails] = useState([]);
  const [matchedSkills, setMatchedSkills] = useState([]);
  const [matchResumeSkills, setMatchResumeSkills] = useState([]);
  const [matchJobSkills, setMatchJobSkills] = useState([]);
  const [resumeCertificationDetails, setResumeCertificationDetails] = useState([]);
  const { user: currentUser } = useSelector(userSelector);

  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs")); // Very small mobile devices
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktopMedium = useMediaQuery('(min-width: 1440px) and (max-width: 1919px)');
  const isDesktopSmall = useMediaQuery('(min-width: 1200px) and (max-width: 1439px)');
  const isDesktopExtraSmall = useMediaQuery('(min-width: 992px) and (max-width: 1199px)');
  const [expanded, setExpanded] = useState(false);

  // Toggle expanded state when clicked
  const handleToggleExpand = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const resumeSkillsSource =
    //resumeDetails?.ai_skills ||
    primaryResumeDetails?.ai_skills ||
    candidateSelectedResume?.ai_skills ||
    "";

  const jobSkillsList = (selectedJob?.required_skills || "")
    .split(",")
    .map((skill) => skill.trim())
    .filter(Boolean);

  const resumeSkillsNormalized = String(resumeSkillsSource)
    .split(",")
    .map((skill) => skill.trim().toLowerCase())
    .filter(Boolean);

  const isJobSkillMatched = (skill) =>
    resumeSkillsNormalized.includes(skill.trim().toLowerCase());

  const matchedJobSkillsCount = jobSkillsList.filter(isJobSkillMatched).length;

  // Matched skills first, then unmatched
  const sortedJobSkills = [
    ...jobSkillsList.filter(isJobSkillMatched),
    ...jobSkillsList.filter((skill) => !isJobSkillMatched(skill)),
  ];

  const visibleJobSkills = expanded
    ? sortedJobSkills
    : sortedJobSkills.slice(0, 12);

  const handleRadioChange = (resume) => {
    setSelectedResume(resume);
  };

  // Function to get matched skills (common skills between resume and job)
  const getMatchedSkill = (resumeSkills, jobSkills) => {
    if (!resumeSkills || !jobSkills) return [];

    // Normalize skills (trim and lowercase for comparison)
    const normalizedResumeSkills = resumeSkills
      .split(',')
      .map(skill => skill.trim().toLowerCase());

    const normalizedJobSkills = jobSkills
      .split(',')
      .map(skill => skill.trim().toLowerCase());

    // Find intersection (common skills)
    const commonSkills = normalizedResumeSkills.filter(skill =>
      normalizedJobSkills.includes(skill)
    );

    // Return original skill names (not normalized)
    return commonSkills.map(skill => skill.charAt(0).toUpperCase() + skill.slice(1));
  };

  useEffect(() => {
    setExpanded(false);
  }, [selectedJob?.id]);

  // Update matchedSkills whenever resumeDetails or selectedJob changes
  useEffect(() => {
    if (resumeDetails?.ai_skills && selectedJob?.required_skills) {
      const matched = getMatchedSkill(
        resumeDetails.ai_skills,
        selectedJob.required_skills
      );
      setMatchedSkills(matched);
      setMatchedSkillsList(matched); // Update matchedSkillsList for rendering
    } else {
      setMatchedSkills([]);
      setMatchedSkillsList([]);
    }
  }, [resumeDetails, selectedJob]);


  // Function to handle opening the dialog
  const handleClickOpen1 = () => {
    setJobForInterest(selectedJob);
    setDialogOpen1(true);
    fetchResumeDetails()
  };

  // Function to handle closing the dialog
  const handleClose1 = () => {
    setDialogOpen1(false);
    setJobForInterest(null);
  };

  const makeContextEmpty = () => {
    contextObject.updateJobTitle("");
    contextObject.updateEmail("");
    contextObject.updatePhone("");
    contextObject.updateExperience("");
    contextObject.updateFinish(false);
    contextObject.updateFinishOne(false);
    contextObject.updateSummary("");
    contextObject.updateAISkills([])
  };

  useEffect(() => {
    // console.log("contextObject", contextObject)
    const resetAction = async () => {
      if (contextObject.finish === true && user?.companyid !== 4854) {
        setJobForInterest(selectedJob);
        setDialogOpen1(true);
        contextObject.updateFinish(false)

      }
    }
    resetAction()

  }, [contextObject.finish])
  useEffect(() => {
    let cancelled = false;
    const fetch = async () => {
      if (!user?.candidate_id) return;

      // Skip re-fetch when parent already loaded this candidate.
      // Avoid selectedCandidateAction here — it clears solrJobs and retriggers list loads.
      if (
        String(candidateDetails?.candidate_id) !== String(user.candidate_id)
      ) {
        await dispatch(getCandidateDetailAction(user.candidate_id));
      }
      if (!cancelled) {
        await getCandidateResumeList();
      }
    };
    fetch();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.candidate_id]);
  const getCandidateResumeList = async () => {
    setResumesLoading(true);
    try {
      const candidateId = user?.candidate_id;
      if (candidateId !== null) {
        const response = await axios.post(
          `${Key.domain}/common/get_candidate_resumes_list`,
          { candidate_id: user?.candidate_id, user_id: user?.id }
        );
        if (response.status === 200) {
          const resumesData = response?.data?.data;
          if (resumesData?.length > 0) {
            await setResumes(resumesData);
            await setSelectedResume(resumesData[0]);
            await getResumeFullDetails(resumesData[0]?.resume_id)
            const primaryResume = resumesData.find(
              (resume) => resume.isPrimary === 1
            );
            //setSelectedResume(primaryResume || resumesData[0]); // Display primary if exists, else first resume
            setSelectedResume(resumesData[0]);
            dispatch(
              candidateSelectedResumeAction(primaryResume || resumesData[0])
            );
          } else {
            setResumes([]);
            setSelectedResume(null);
            setOpenFileUpload(true);
          }
        } else {
          console.log("No data in response");
          setResumes([]);
        }
      } else {
        console.log("No candidate ID found");
        setResumes([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setResumes([]);
    } finally {
      setResumesLoading(false);
    }
  };


  useEffect(() => {
    const fetch = async () => {
      if (
        typeof resumeDetails?.ai_skills === "string" &&
        typeof selectedJob?.required_skills === "string"
      ) {
        const resumeSkills = await resumeDetails?.ai_skills.split(",");
        const jobSkills = await selectedJob?.required_skills.split(",");
        // Logging the skills for debugging
        // console.log('Resume Skills:', resumeSkills);
        // console.log('Job Skills:', jobSkills);
        setMatchResumeSkills(removeDuplicates(resumeSkills));
        setMatchJobSkills(removeDuplicates(jobSkills));
        const matchedSkills = await getMatchedSkills(resumeSkills, jobSkills);
        setMatchedSkills(matchedSkills);

      }
    };
    fetch();
  }, [resumeDetails, jobDetails]);

  const removeDuplicates = (arr) => {
    const lowerCaseSet = new Set();
    const result = [];
    // console.log("arr", arr);
    arr.forEach((item) => {
      const lowerCaseItem = item.trim().toLowerCase();
      if (!lowerCaseSet.has(lowerCaseItem)) {
        lowerCaseSet.add(lowerCaseItem);
        result.push(item);
      }
    });
    // console.log("result", result);

    return result;
  };
  const getMatchedSkills = (resumeSkills, jobSkills) => {
    const finalResumeSkills = removeDuplicates(resumeSkills);
    const finalJobSkills = removeDuplicates(jobSkills);

    // console.log("finalresumeskills", finalResumeSkills);
    // console.log("finaljobSkills", finalJobSkills);


    const matches = [];
    if (!finalResumeSkills || !finalJobSkills) {
      return matches;
      // setMatchedSkills([]);
    }
    // setMatchedSkills([]);
    finalResumeSkills.forEach((skill1) => {
      finalJobSkills.forEach((skill2) => {
        const normalSkill1 = skill1.toLowerCase();
        const normalSkill2 = skill2.toLowerCase();

        if (
          normalSkill1 === normalSkill2 ||
          normalSkill2.includes(normalSkill1) ||
          normalSkill1.includes(normalSkill2)
        ) {
          matches.push(skill1);
          // matches.push(skill2);
          // setMatchedSkills([...matchedSkills, skill2]);
        }
      });
    });
    return matches;
  };


  const getResumeFullDetails = async (resumeId) => {
    if (!resumeId) return;
    setResumeDetailsLoading(true);
    try {
      const response = await axios.post(`${Key.domain}/common/get_js_resume_details`, {
        user_id: null,
        resumeid: resumeId,

      });
      await setResumeFullDetails(response?.data?.data?.projectdetails);
      // console.log("project details", response?.data?.data?.projectdetails)
      setResumeCertificationDetails(response?.data?.data?.certificatedetails);
      // console.log("resdet", response?.data.data.resumedetails);
      setResumeDetails(response.data.data.resumedetails);
      setProjectDetails(response.data.data.projectdetails);
      // console.log('Updated resume details:', response.data.data.projectdetails);
      //return response.data.resumeDetails;
    } catch (error) {
      console.error("Error fetching resume details:", error);
    } finally {
      setResumeDetailsLoading(false);
    }
  };
  const fetchResumeDetails = async () => {
    const primaryResumeId = resumeId ? resumeId : primaryResumeDetails?.id
    // console.log('Fetching resume details for ID:', primaryResumeId);
    const resumeDetails = await getResumeFullDetails(primaryResumeId);
    if (resumeDetails && resumeDetails.skills) {
      setSkillsInResume(resumeDetails.skills);
    } else {
      setSkillsInResume([]);
    }
  };

  useEffect(() => {

    if (resumeId) {
      fetchResumeDetails();
    }
  }, [resumeId]);
  useEffect(() => {
    if (selectedJob?.id && !selectedJobLoading) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [selectedJob?.id, selectedJobLoading]);

  const handleButtonClick = async () => {
    setDialogOpen1(false);  // Close the dialog after submission
    // Use the job that was active when Interested was clicked, not whatever
    // Redux may have been overwritten to after a jobs-list refresh.
    const job = jobForInterest || selectedJob;
    setJobForInterest(null);

    setSeverity("success");
    let updatedDetails = {
      jobId: job?.id,
      candidateId: candidateDetails?.candidate_id,
      userId: user?.user_id,
      status: 1,
      recruiter_email: job?.email_id,
      candidate_name: candidateDetails?.candidate_name,
      candidate_email: candidateDetails?.email,
      job_title: job?.jobtitle,
      company_name: job?.company_name,
      recruiter_name: job?.contact_name,
      resume_id: selectedResume?.resume_id
    };
    // console.log("updatedDetails", updatedDetails);
    // console.log("candidateDetails", candidateDetails);
    const InterestedJobResponse = await dispatch(updateInterestedJobAction(updatedDetails));
    getCandidateInterestedJobDetails();

    setSnackbarOpen(true);
    setSnackbarMessage("Interested Job Updated");
    if (currentSection?.isRedirect === true) {
      await dispatch(resetResumeAction())
      await makeContextEmpty()
    }

    if (
      InterestedJobResponse?.results?.affectedRows > 0 ||
      InterestedJobResponse?.results?.insertId
    ) {
      const notifyData = {
        user_id: user?.candidate_id,
        notifiedto: user?.user_id,
        notificationDescription: "has Shown Interest in the Job Position",
        notificationSubject: "Interested",
        notificationType: "",
        job_id: job?.id,
        candidate_name: user?.candidate_name,
        job_title: job?.jobtitle,
      };
      await dispatch(creteNotificationAction(notifyData));
      setSnackbarOpen(true);
      setSnackbarMessage("Notification Sent to Recruiter");

      // Display an alert with the selected resume details
      // if (selectedResume) {
      //   alert(`Selected Resume: ${selectedResume?.filename || "No Name"}`);
      // } else {
      //   alert("No resume selected.");
      // }
    }
    else {
      if (!selectedResume) {
        alert("No resume selected.");
      }
      setSnackbarOpen(true);
      //console.log("InterestedJobResponse", InterestedJobResponse);
      setSnackbarMessage(InterestedJobResponse || "Failed to update interested job");
    }
  };

  const handleNotInterested = async () => {
    setSeverity("error");
    let updatedDetails = {
      jobId: selectedJob.id,
      candidateId: user?.candidate_id,
      userId: user?.user_id,
      status: 0,
    };

    await dispatch(updateInterestedJobAction(updatedDetails));
    getCandidateInterestedJobDetails();
    setSnackbarOpen(true);
    setSnackbarMessage("Interested Job Updated");
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleApply = () => {
    setDialogOpen(false);
    setInterestedJobIds(true);
    setToastOpen(true);
  };
  const getCandidateInterestedJobDetails = async () => {
    if (!selectedJob?.id || !candidateDetails?.candidate_id) return;

    let updatedDetails = {
      jobId: selectedJob?.id,
      candidateId: candidateDetails?.candidate_id,
      userId: user?.user_id,
    };
    const response = await dispatch(getInterestedJobAction(updatedDetails));
    if (
      response?.results?.[0]?.candidate_id === candidateDetails?.candidate_id
    ) {
      setNotInteretedJobIds(response.results[0]?.not_interested_jobids);
      setInterestedJobIds(response?.results[0]?.job_ids);
    }
  };
  useEffect(() => {
    if (!selectedJob?.id || !candidateDetails?.candidate_id) return;

    let cancelled = false;
    const run = async () => {
      let updatedDetails = {
        jobId: selectedJob.id,
        candidateId: candidateDetails.candidate_id,
        userId: user?.user_id,
      };
      const response = await dispatch(getInterestedJobAction(updatedDetails));
      if (cancelled) return;
      if (
        response?.results?.[0]?.candidate_id === candidateDetails.candidate_id
      ) {
        setNotInteretedJobIds(response.results[0]?.not_interested_jobids);
        setInterestedJobIds(response?.results[0]?.job_ids);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [selectedJob?.id, candidateDetails?.candidate_id, user?.user_id, dispatch]);

  const handleTitleClick = (resume) => {
    setSelectedResume(resume);
  };



  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  const Bullet = styled("span")({
    display: "inline-block",
    width: "3px",
    height: "3px",
    borderRadius: "50%",
    backgroundColor: "currentColor",
  });

  const skillBtnStyles = {
    bgcolor: skillsOpen ? "rgba(64, 104, 130, 0.9)" : "",
    color: skillsOpen ? "#fff" : "rgba(0,0,0,0.6)",
    border: skillsOpen ? "none" : "1px solid #ddd",
  };
  const workBtnStyles = {
    bgcolor: summaryOpen ? "rgba(64, 104, 130, 0.9)" : "",
    color: summaryOpen ? "#fff" : "rgba(0,0,0,0.6)",
    border: summaryOpen ? "none" : "1px solid #ddd",
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "rgba(64, 104, 130, 0.9)",
      //  theme.palette.common.black,
      color: theme.palette.common.white,
      fontSize: styles.fontSize14,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: styles.fontSize14,
    },
  }));

  const btnStyles = {
    borderRadius: "25px",
    padding: "0px 15px 0px 15px",
    textTransform: "capitalize",
    border: "1px solid #ddd",
    color: "rgba(0,0,0,0.6)",
    fontSize: styles.fontSize14,
    "&:hover": {
      bgcolor: "#406882",
      color: "#fff",
      border: "1px solid #406882",
    },
  };
  const TimelineConnector = styled('div')(({ theme }) => ({
    width: '3px',
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    left: '33px', // Adjust based on logo positioning
    top: "77px",
    bottom: 0,
  }));

  const TimelineDot = styled(Box)(({ theme }) => ({
    height: 40,
    width: 43,
    borderRadius: '50%',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.primary.main}`,
  }));

  const HandleOptimiseRedirection = () => {
    makeContextEmpty();

    const resumeId =
      primaryResumeDetails?.id ?? candidateSelectedResume?.resume_id;

    if (!resumeId) {
      console.error("Resume ID not found. Cannot redirect.");
      return;
    }

    navigate(`/resume/optimise/resume_${resumeId}`);
  };

  const HandleAdvancedOptimiseRedirection = () => {
    const resumeId =
      primaryResumeDetails?.id ?? candidateSelectedResume?.resume_id;

    if (!resumeId) {
      console.error("Resume ID not found. Cannot redirect.");
      return;
    }

    runAdvancedOptimise({
      resumeId,
      jobDescription: selectedJob?.job_description,
      jobTitle: selectedJob?.jobtitle,
    });
  };

  const paperStyles = {
    borderRadius: "8px",
    height: "100%",
    overflow: "hidden",
    padding: 0,
    display: "flex",
    flexDirection: "column",
  };

  return (
    <Paper elevation={2} sx={paperStyles}>
      <AdvancedOptimiseAnalysingDialog open={advancedAnalysing} />
      <Snackbar
        open={Boolean(advancedError)}
        autoHideDuration={6000}
        onClose={clearAdvancedError}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" onClose={clearAdvancedError} sx={{ width: "100%" }}>
          {advancedError}
        </Alert>
      </Snackbar>
      <Stack sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        {loading || !selectedJob ? (
          <Box sx={{ p: 1.5 }}>
            <Skeleton variant="text" height={40} />
            <Skeleton variant="text" height={20} width="60%" />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Skeleton
                variant="rectangular"
                width={150}
                height={36}
                sx={{ mr: 1 }}
              />
              <Skeleton variant="rectangular" width={150} height={36} />
            </Box>
            <Skeleton variant="text" height={30} sx={{ mt: 4 }} />
            <Skeleton variant="rectangular" height={200} />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                bgcolor: "#fff",
                px: 1.5,
                pt: 1.5,
                pb: 1.5,
                borderBottom: "1px solid #e8eef2",
                zIndex: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "24px",
                }}
              >
                {selectedJob?.jobtitle}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "rgba(0, 0, 0, 0.6)",
                  fontSize: "13px",
                  marginTop: "8px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {selectedJob?.company_name} • {selectedJob?.location ? selectedJob.location : "Remote"}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <Box sx={{ px: 1.5, pt: 1.5, pb: 1.5 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Stack direction="column" gap={1} sx={{ width: "100%" }}>
                <Tooltip

                >
                  <Typography
                    paragraph
                    sx={{
                      margin: 0,
                      display: "flex",
                      alignItems: "end",
                      gap: "2px",
                      fontSize: "12px", // Set font size in pixels
                      minWidth: "80px",
                      maxWidth: isDesktopLarge ? "500px" : "200px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <BusinessCenterRounded
                      sx={{
                        height: isDesktopLarge ? "20px" : "18px",
                        width: isDesktopLarge ? "20px" : "18px",
                        color: "#757575",
                        marginRight: "5px",
                      }}
                    />
                    {selectedJob?.jobtype_name !== undefined &&
                      selectedJob?.jobtype_name !== null
                      ? selectedJob?.jobtype_name
                      : "Full Time"}
                  </Typography>
                </Tooltip>
                {selectedJob?.experience != null &&
                  String(selectedJob.experience).trim() !== "" && (
                    <Typography
                      paragraph
                      sx={{
                        margin: 0,
                        display: "flex",
                        alignItems: "end",
                        gap: "2px",
                        fontSize: "12px",
                        minWidth: "80px",
                        maxWidth: isDesktopLarge ? "500px" : "200px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <WorkHistoryRounded
                        sx={{
                          height: isDesktopLarge ? "20px" : "18px",
                          width: isDesktopLarge ? "20px" : "18px",
                          color: "#757575",
                          marginRight: "5px",
                        }}
                      />
                      {String(selectedJob.experience).trim() === "0"
                        ? "0 - 3 Years"
                        : selectedJob.experience}
                    </Typography>
                  )}
                <Box sx={{ width: "100%", mb: 1.5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 0.75,
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "rgba(0,0,0,0.7)",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        m: 0,
                        lineHeight: 1.2,
                      }}
                    >
                      <ChecklistRtlRounded
                        sx={{
                          height: isDesktopLarge ? 20 : 18,
                          width: isDesktopLarge ? 20 : 18,
                          color: "#757575",
                        }}
                      />
                      Required Skills
                    </Typography>
                    {jobSkillsList.length > 0 && (
                      <Typography
                        sx={{
                          fontSize: 11,
                          color: "rgba(0,0,0,0.55)",
                          m: 0,
                          lineHeight: 1.2,
                        }}
                      >
                        {matchedJobSkillsCount}/{jobSkillsList.length} matched
                      </Typography>
                    )}
                  </Box>

                  {jobSkillsList.length > 0 ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.75,
                          width: "100%",
                          // Align chips under "Required Skills" text (after icon)
                          pl: isDesktopLarge ? "25px" : "23px",
                        }}
                      >
                        {visibleJobSkills.map((skill, index) => {
                          const matched = isJobSkillMatched(skill);
                          return (
                            <Chip
                              key={`${skill}-${index}`}
                              size="small"
                              label={skill}
                              sx={{
                                height: 26,
                                fontSize: 11,
                                fontWeight: 500,
                                bgcolor: matched
                                  ? "rgba(46, 125, 50, 0.08)"
                                  : "rgba(0, 0, 0, 0.04)",
                                color: matched ? "#2e7d32" : "#616161",
                                border: "1px solid",
                                borderColor: matched ? "#2e7d32" : "#bdbdbd",
                              }}
                            />
                          );
                        })}
                      </Box>
                      {sortedJobSkills.length > 12 && (
                        <Button
                          size="small"
                          onClick={handleToggleExpand}
                          sx={{
                            mt: 0.75,
                            mb: 0.5,
                            ml: isDesktopLarge ? "25px" : "23px",
                            textTransform: "none",
                            fontSize: 12,
                            color: "#406882",
                            p: 0,
                            minWidth: 0,
                          }}
                        >
                          {expanded
                            ? "Show less"
                            : `Show ${sortedJobSkills.length - 12} more`}
                        </Button>
                      )}
                    </>
                  ) : (
                    <Typography sx={{ fontSize: 12, color: "text.secondary", pl: isDesktopLarge ? "25px" : "23px" }}>
                      N/A
                    </Typography>
                  )}
                </Box>
              </Stack>
            </Box>
            <Stack style={{ width: "100%", marginTop: 8 }}>
              {/* Dialog Component */}
              <Dialog
                open={dialogOpen1}
                onClose={handleClose1}
                maxWidth="xl"
                fullWidth
                sx={{
                  "& .MuiDialog-paper": {
                    width: "94vw",
                    maxWidth: "94vw",
                    height: "calc(100vh - 56px)",
                    maxHeight: "calc(100vh - 56px)",
                    borderRadius: 2,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    px: 2.5,
                    py: 1.5,
                    bgcolor: "#f7f9fb",
                    borderBottom: "1px solid #e8eef2",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                    <Box>
                      <Typography sx={{ fontWeight: 700, fontSize: "1.05rem", color: "#2c3e50" }}>
                        Select Resume
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: "rgba(0,0,0,0.55)", mt: 0.25 }}>
                        Pick a resume to continue with this job
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "center", display: isMobile || isMobileSmall ? "none" : "block" }}>
                      {selectedResume && (
                        <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#406882", bgcolor: "rgba(64,104,130,0.08)", px: 1.5, py: 0.5, borderRadius: 1 }}>
                          #{selectedResume?.resume_id} · {selectedResume?.application_title}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        onClick={handleClose1}
                        variant="outlined"
                        color="primary"
                        size="small"
                        sx={{ borderRadius: 1.5, textTransform: "none", fontSize: 13, px: 2 }}
                      >
                        Close
                      </Button>
                      <Button
                        onClick={handleButtonClick}
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={{
                          borderRadius: 1.5,
                          textTransform: "none",
                          fontSize: 13,
                          px: 2.5,
                          bgcolor: "#406882",
                          "&:hover": { bgcolor: "#335468" },
                        }}
                      >
                        Continue
                      </Button>
                    </Box>
                  </Box>
                </DialogTitle>

                <DialogContent sx={{ p: 0, flex: 1, overflow: "hidden" }}>
                  <Grid container sx={{ height: "100%", m: 0 }}>
                    <Grid
                      item
                      xs={isMobile || isMobileSmall || isTablet ? 12 : 3}
                      sx={{
                        height: { xs: 240, md: "100%" },
                        borderRight: { md: "1px solid #e8eef2" },
                        bgcolor: "#fafbfc",
                      }}
                    >
                      <Box sx={{ height: "100%", overflowY: "auto", p: 1.5 }}>
                        {resumesLoading ? (
                          <Stack spacing={1}>
                            {[1, 2, 3, 4].map((item) => (
                              <Skeleton
                                key={item}
                                variant="rounded"
                                height={72}
                                sx={{ borderRadius: 1.5 }}
                              />
                            ))}
                          </Stack>
                        ) : resumes?.length > 0 ? (
                          resumes.map((resume, index) => {
                            const isSelected = selectedResume?.resume_id === resume.resume_id;
                            return (
                            <Card
                              key={index}
                              onClick={() => {
                                handleRadioChange(resume);
                                getResumeFullDetails(resume?.resume_id);
                              }}
                              sx={{
                                height: 72,
                                boxShadow: "none",
                                borderRadius: 1.5,
                                border: "1px solid",
                                borderColor: isSelected ? "#406882" : "#e2e8ee",
                                bgcolor: isSelected ? "rgba(64,104,130,0.06)" : "#fff",
                                mb: 1,
                                cursor: "pointer",
                                overflow: "hidden",
                                "&:hover": {
                                  borderColor: "#406882",
                                  bgcolor: "rgba(64,104,130,0.04)",
                                },
                              }}
                            >
                                <Grid container sx={{ height: "100%" }}>
                                  <Grid
                                    item
                                    xs={2}
                                    sx={{
                                      bgcolor: resume.filetype === "pdf" ? "#c62828" : "#1565c0",
                                      color: "#fff",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: 11,
                                      fontWeight: 700,
                                    }}
                                  >
                                    {resume.filetype === "pdf" ? "PDF" : "DOC"}
                                  </Grid>
                                  <Grid item xs={8} sx={{ px: 1.25, py: 1, display: "flex", flexDirection: "column", justifyContent: "center", minWidth: 0 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
                                          <Typography
                                            sx={{
                                              mb: 0,
                                              fontWeight: 600,
                                              fontSize: 13,
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              minWidth: 0,
                                            }}
                                          >
                                            {resume.application_title}
                                          </Typography>
                                          {resume?.isPrimary === 1 && (
                                            <Tooltip title="Primary Resume" arrow>
                                              <StarRoundedIcon
                                                sx={{
                                                  fontSize: 16,
                                                  color: "#e4a43c",
                                                  flexShrink: 0,
                                                }}
                                              />
                                            </Tooltip>
                                          )}
                                        </Box>
                                    <Typography sx={{ mb: 0, fontSize: 11, color: "#757575" }}>
                                      {resume.created !== undefined &&
                                        resume.created !== null &&
                                        moment(resume.created).fromNow() !== "Invalid date"
                                        ? moment(resume.created).fromNow()
                                        : "—"}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={2}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Radio
                                      checked={isSelected}
                                      onChange={() => { handleRadioChange(resume); getResumeFullDetails(resume?.resume_id) }}
                                      value={resume.resume_id}
                                      name="resume-selection"
                                      size="small"
                                      inputProps={{ "aria-label": `Select ${resume?.application_title}` }}
                                    />
                                  </Grid>
                                </Grid>
                              </Card>
                            );
                          })
                        ) : null}
                      </Box>
                    </Grid>

                    {/*Resume Preview */}
                    <Grid
                      item
                      xs={isMobile || isMobileSmall || isTablet ? 12 : 5}
                      sx={{
                        height: { xs: 360, md: "100%" },
                        borderRight: { md: "1px solid #e8eef2" },
                      }}
                    >
                      <Box sx={{ height: "100%", overflow: "auto", p: 1.5 }}>
                        {resumesLoading || resumeDetailsLoading ? (
                          <Stack spacing={1.5} sx={{ height: "100%" }}>
                            <Skeleton variant="rounded" height="100%" sx={{ minHeight: 280, borderRadius: 1.5 }} />
                          </Stack>
                        ) : selectedResume ? (
                          <ResumePdfViewer
                            resume_id={selectedResume?.resume_id}
                            file_name={selectedResume?.filename}
                          />
                        ) : null}
                      </Box>

                    </Grid>
                    {/*Resume Preview end */}


                    {/*Resume details */}

                    <Grid
                      item
                      xs={isMobile || isMobileSmall || isTablet ? 12 : 4}
                      sx={{ height: { xs: "auto", md: "100%" } }}
                    >
                      <Box sx={{ height: "100%", overflowY: "auto", p: 1.5 }}>
                        {resumesLoading || resumeDetailsLoading ? (
                          <Stack spacing={1.5}>
                            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                              <Skeleton variant="circular" width={72} height={72} />
                              <Box sx={{ flex: 1 }}>
                                <Skeleton variant="text" width="60%" height={24} />
                                <Skeleton variant="text" width="80%" height={18} />
                                <Skeleton variant="text" width="70%" height={18} />
                              </Box>
                            </Box>
                            <Skeleton variant="rounded" height={48} sx={{ borderRadius: 1.5 }} />
                            <Skeleton variant="rounded" height={48} sx={{ borderRadius: 1.5 }} />
                            <Skeleton variant="rounded" height={36} width={180} sx={{ mx: "auto", borderRadius: 2 }} />
                            <Skeleton variant="rounded" height={220} sx={{ borderRadius: 1.5 }} />
                          </Stack>
                        ) : selectedResume ? (
                          <Box sx={{ overflow: "visible" }}>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1.5,
                                alignItems: "center",
                                p: 1.5,
                                mb: 1.5,
                                borderRadius: 1.5,
                                border: "1px solid #e8eef2",
                                bgcolor: "#fafbfc",
                              }}
                            >
                              <Avatar
                                sx={{
                                  height: 72,
                                  width: 72,
                                  bgcolor: "#406882",
                                  fontWeight: 700,
                                  fontSize: 24,
                                }}
                              >
                                {(selectedResume?.full_name || "?").charAt(0).toUpperCase()}
                              </Avatar>
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                                  <Typography
                                    sx={{
                                      margin: 0,
                                      fontWeight: 700,
                                      color: "rgba(0,0,0,0.75)",
                                      textTransform: "capitalize",
                                      fontSize: styles.fontSize16,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {selectedResume?.full_name}
                                  </Typography>
                                  {candidateDetails?.linkedin_url !== null &&
                                    candidateDetails?.linkedin_url !== undefined &&
                                    candidateDetails?.linkedin_url !== "" && (
                                      <Box
                                        sx={{
                                          border: "1px solid #ddd",
                                          borderRadius: "6px",
                                          display: "flex",
                                          "&:hover": {
                                            bgcolor: "#406882",
                                            ".inicon": {
                                              color: "#fff",
                                              cursor: "pointer",
                                            },
                                          },
                                          ".inicon": {
                                            color: "#406882",
                                          },
                                        }}
                                      >
                                        <TiSocialLinkedin
                                          className="inicon"
                                          style={{ height: styles.icon20, width: '26px', cursor: 'pointer' }}
                                          onClick={() => window.open(candidateDetails?.linkedin_url, "_blank")}
                                        />
                                      </Box>
                                    )}
                                </Box>
                                {selectedResume?.home_phone && selectedResume?.home_phone !== "N/A" && (
                                  <Typography sx={{ fontSize: 12, color: "rgba(0,0,0,0.65)", display: "flex", alignItems: "center", gap: 0.5 }}>
                                    <PhoneRounded sx={{ height: 12, width: 12 }} />
                                    {selectedResume?.home_phone}
                                  </Typography>
                                )}
                                {selectedResume?.email_address && (
                                  <Typography sx={{ fontSize: 12, color: "rgba(0,0,0,0.65)", display: "flex", alignItems: "center", gap: 0.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    <EmailRounded sx={{ height: 12, width: 12 }} />
                                    {selectedResume?.email_address}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                            <Card sx={{ boxShadow: "none", border: "1px solid #e8eef2", borderRadius: 1.5, mb: 1, px: 1.5, py: 1 }}>
                              <Grid container spacing={0}>
                                <Grid item xs={4}>
                                  <Typography
                                    paragraph
                                    sx={{
                                      margin: 0,
                                      fontWeight: 500,
                                      fontSize: styles.fontSize14,
                                      color: "rgba(0,0,0,0.6)",
                                    }}
                                  >
                                    Role
                                  </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                  <Typography
                                    title={selectedResume?.application_title}
                                    paragraph
                                    sx={{
                                      margin: 0,
                                      fontWeight: 600,
                                      fontSize: styles.fontSize14,
                                      color: "rgba(0,0,0,0.9)",
                                    }}
                                  >
                                    {selectedResume?.application_title
                                      ? selectedResume.application_title.length > 20
                                        ? `${selectedResume.application_title.slice(0, 30)}...`
                                        : selectedResume.application_title
                                      : "N/A"}                                  {/* Scrum Master/Project Manager */}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Card>
                            {/* <Card sx={{ boxShadow: "none", border: "1px solid #e8eef2", borderRadius: 1.5, mb: 1, px: 1.5, py: 1 }}>
                              <Grid container spacing={0}>
                                <Grid item xs={4}>
                                  <Typography
                                    paragraph
                                    sx={{
                                      margin: 0,
                                      fontWeight: 500,
                                      fontSize: styles.fontSize14,
                                      color: "rgba(0,0,0,0.6)",
                                    }}
                                  >
                                    Job Type
                                  </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                  <Typography
                                    paragraph
                                    sx={{
                                      margin: 0,
                                      fontWeight: 600,
                                      fontSize: styles.fontSize14,
                                      color: "rgba(0,0,0,0.9)",
                                    }}
                                  >
                                    {selectedResume?.jobtypeNames
                                      ? selectedResume?.jobtypeNames
                                      : selectedResume?.res_jobtypeName?.map((i) => i).join(", ") ? selectedResume?.res_jobtypeName?.map((i) => i).join(", ") : 'N/A'}

                                  </Typography>
                                </Grid>
                              </Grid>
                            </Card> */}
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                              <Stack direction="row" spacing={1} sx={{ p: "4px", mt: 1 }}>
                                <Button
                                  variant="outlined"
                                  sx={{ ...btnStyles, ...skillBtnStyles }}
                                  startIcon={
                                    <ManageAccountsRounded
                                      sx={{ height: "16px", width: "16px", minWidth: "10px" }}
                                    />
                                  }
                                  onClick={() => {
                                    setSummaryOpen(false);
                                    setSkillsOpen(true);
                                  }}
                                >
                                  Skills
                                </Button>
                                <Button
                                  variant="outlined"
                                  startIcon={
                                    <BusinessCenterRounded sx={{ height: "16px", width: "16px" }} />
                                  }
                                  sx={{ ...btnStyles, ...workBtnStyles }}
                                  onClick={() => {
                                    setSkillsOpen(false);
                                    setSummaryOpen(true);

                                  }}
                                >
                                  Work
                                </Button>
                                {/*  <Button
              variant="outlined"
              startIcon={
                <DescriptionRounded sx={{ height: "16px", width: "16px" }} />
              }
              sx={{ ...btnStyles }}
            >
              Notes
            </Button> */}
                              </Stack>
                            </Box>

                            <Card sx={{ boxShadow: "none" }}>
                              <CardContent>
                                {skillsOpen ? (
                                  <Card
                                    sx={{
                                      boxShadow: "none",
                                      border: "1px solid #ddd",
                                      borderRadius: "6px",
                                      p: isDesktopLarge ? 2 : 1,
                                    }}
                                  >
                                    <CardHeader
                                      title={
                                        <Typography
                                          paragraph
                                          style={{
                                            fontSize: styles.fontSize18,
                                            fontWeight: 400,
                                            margin: 0,
                                          }}
                                        >
                                          How{" "}
                                          <span
                                            style={{
                                              fontWeight: 500,
                                              color: "#e4a43c",
                                            }}
                                          >
                                            {selectedResume?.application_title}
                                            {/* Scrum Master/Project Manager */}
                                          </span>{" "}
                                          match
                                        </Typography>
                                      }
                                    />
                                    <CardContent
                                      sx={{
                                        bgcolor: "#ffefcd",
                                        height: "auto",
                                        maxheight: "40vh",
                                        overflow: "scroll",
                                        borderRadius: "6px",
                                        p: 1,
                                      }}
                                    >
                                      {matchedSkillsList?.length > 6 ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            "&:hover": {
                                              textu: {
                                                textDecoration: "underline",
                                                color: "blue",
                                              },
                                            },
                                          }}
                                        >
                                          <WorkspacePremiumRounded
                                            sx={{
                                              color: "#e4a43c",
                                              height: isDesktopLarge ? "36px" : "28px",
                                              width: isDesktopLarge ? "36px" : "28px",
                                              mr: "5px",
                                            }}
                                          />
                                          <p
                                            style={{
                                              fontSize: styles.fontSize14,
                                              margin: 0,
                                            }}
                                            onClick={() => setMatchedSkillsOpen(true)}
                                          >
                                            <span
                                              className={`${matchedSkills?.length > 0 ? "match-text" : ""
                                                }`}
                                            >
                                              {matchedSkills.length > 0
                                                ? `${matchedSkills.length} of ${matchJobSkills.length} skills match your profile - you may be a good fit`
                                                : `Skills: ${matchJobSkills.join(",")}`}
                                            </span>
                                            <span
                                              style={{
                                                background: "#e4a43c",
                                                fontWeight: 500,
                                                paddingInline: "7px",
                                                color: "#fff",
                                                borderRadius: "4px",
                                                margin: 0,
                                              }}
                                            >
                                              {selectedResume?.application_title}
                                            </span>
                                          </p>
                                        </Box>
                                      ) : (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            "&:hover": {
                                              ".match-text": {
                                                color: "#406882",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                              },
                                            },
                                          }}
                                        >
                                          <AssignmentLateRounded
                                            sx={{
                                              color: "#e4a43c",
                                              height: isDesktopLarge ? "36px" : "28px",
                                              width: isDesktopLarge ? "36px" : "28px",
                                              mr: "5px",
                                            }}
                                          />
                                          <Typography
                                            variant="body1"
                                            paragraph
                                            style={{ fontSize: styles.fontSize14 }}
                                            onClick={() =>
                                              // matchedSkills?.length > 0 &&
                                              setMatchedSkillsOpen(true)
                                            }
                                          >
                                            <span
                                              className={`${matchedSkillsList?.length > 0 ? "match-text" : ""
                                                }`}
                                            >
                                              {matchedSkillsList?.length} of{" "}
                                              {matchJobSkills.length > 0
                                                ? matchJobSkills.length
                                                : 0}{" "}
                                              skills matched based on skills with
                                              experience for&nbsp;
                                            </span>
                                            <span
                                              style={{
                                                background: "#e4a43c",
                                                fontWeight: 500,
                                                paddingInline: "7px",
                                                color: "#fff",
                                                borderRadius: "4px",
                                                margin: 0,
                                              }}
                                            >
                                              {selectedResume?.application_title}
                                            </span>
                                          </Typography>
                                        </Box>
                                      )}
                                      {matchedSkillsOpen && (
                                        <List sx={{ maxHeight: "200px", overflowY: "auto" }}>
                                          <Grid container spacing={0}>
                                            {matchedSkillsList.map((skill, index) => (
                                              <Grid item xs={6} key={index}>
                                                <ListItem sx={{ p: 0 }}>
                                                  <ArrowRightOutlined />
                                                  <Typography variant="body2" sx={{ fontSize: styles.fontSize12 }}>
                                                    {skill}
                                                  </Typography>
                                                </ListItem>
                                              </Grid>
                                            ))}
                                          </Grid>
                                        </List>
                                      )}
                                    </CardContent>
                                    <CardContent sx={{ p: 0, mt: 1 }}>
                                      <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                          <TableContainer
                                            component={Paper}
                                            sx={{ maxHeight: 400 }}
                                          >
                                            <Table
                                              aria-label="customized table"
                                              stickyHeader
                                              size="small"
                                            >
                                              <TableHead>
                                                <TableRow>
                                                  <StyledTableCell>Resume Skills</StyledTableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {resumeDetails?.ai_skills
                                                  ?.split(',')
                                                  .map((skill, index) => (
                                                    <StyledTableRow key={index}>
                                                      <StyledTableCell component="th" scope="row">
                                                        {skill.trim()}
                                                      </StyledTableCell>
                                                    </StyledTableRow>
                                                  )) || (
                                                    <StyledTableRow>
                                                      <StyledTableCell component="th" scope="row">
                                                        No AI skills available
                                                      </StyledTableCell>
                                                    </StyledTableRow>
                                                  )}
                                              </TableBody>

                                            </Table>
                                          </TableContainer>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <TableContainer
                                            component={Paper}
                                            sx={{ maxHeight: 400 }}
                                          >
                                            <Table
                                              aria-label="customized table"
                                              stickyHeader
                                              size="small"
                                            >
                                              <TableHead>
                                                <TableRow>
                                                  <StyledTableCell >
                                                    Required Skills
                                                  </StyledTableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {selectedJob?.required_skills
                                                  ?.split(',')
                                                  .map((skill, index) => (
                                                    <StyledTableRow key={index}>
                                                      <StyledTableCell component="th" scope="row">
                                                        {skill.trim()}
                                                      </StyledTableCell>
                                                    </StyledTableRow>
                                                  ))}
                                              </TableBody>



                                            </Table>
                                          </TableContainer>
                                        </Grid>
                                      </Grid>
                                    </CardContent>
                                  </Card>
                                ) : summaryOpen ? (
                                  <>
                                    <Card sx={{ border: '1px solid #ddd', position: 'relative' }}>
                                      <CardHeader
                                        title={
                                          <Typography
                                            paragraph
                                            style={{ fontSize: styles.fontSize18, fontWeight: 500, margin: 0 }}
                                          >
                                            Experience
                                          </Typography>
                                        }
                                        sx={{ borderBottom: '1px solid #ddd' }}
                                      />
                                      <CardContent>
                                        {projectDetails && projectDetails.length > 0 && (
                                          <TimelineConnector />
                                        )}
                                        {projectDetails &&
                                          projectDetails.map((data, index) => (
                                            <Stack
                                              direction="row"
                                              spacing={1}
                                              key={index}
                                              sx={{
                                                position: 'relative',
                                                alignItems: 'center',
                                                marginBottom: index < projectDetails.length - 1 ? 3 : 0,
                                              }}
                                            >
                                              <TimelineDot sx={{ height: styles.Avatar40, width: "43px" }}>
                                                {/* <img
                                                      // src="https://media.licdn.com/dms/image/v2/C510BAQEHVEJVhOPGbg/company-logo_200_200/company-logo_200_200/0/1630573318902/nitya_software_solutions_india_logo?e=2147483647&v=beta&t=ELBy1m6h0EIO-2gplFCqMpkzCPakUFIleZQ70RFlND4" // Assuming `pro_logo` is the URL of the logo
                                                      src={ <Avatar/> }
                                                      alt={`${data?.pro_client} logo`}
                                                      style={{ height: '100%', width: '100%', objectFit: 'contain' }}
                                                    />  */}
                                                <WorkOutlineIcon style={{ height: '70%', width: '100%', objectFit: 'contain', color: "#a79e9e" }} />
                                              </TimelineDot>
                                              <Box sx={{ marginLeft: 3, width: "100%" }}>
                                                <Paper sx={{ padding: "5px" }}>
                                                  <Typography
                                                    variant="body2"
                                                    component="p"
                                                    fontWeight={600}
                                                    sx={{
                                                      margin: 0,
                                                      fontSize: styles.fontSize14,
                                                      color: 'rgba(0,0,0,0.8)',
                                                      lineHeight: 1.5,
                                                    }}
                                                  >
                                                    {data?.pro_role}
                                                  </Typography>
                                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Breadcrumbs separator="-" aria-label="breadcrumb">
                                                      <Typography
                                                        variant="body2"
                                                        component="p"
                                                        sx={{
                                                          fontSize: styles.fontSize13,
                                                          lineHeight: 1.42,
                                                          color: 'rgba(0,0,0,0.6)',
                                                        }}
                                                      >
                                                        {data?.pro_client}
                                                      </Typography>
                                                    </Breadcrumbs>
                                                  </Box>
                                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Breadcrumbs separator="•" aria-label="breadcrumb">
                                                      <Typography
                                                        variant="body2"
                                                        component="p"
                                                        sx={{
                                                          fontSize: styles.fontSize12,
                                                          color: 'rgba(0,0,0,0.5)',
                                                        }}
                                                      >
                                                        {moment(data?.pro_startdate).format('ll')} -{' '}
                                                        {moment(data?.pro_enddate).format('ll') === 'Invalid date'
                                                          ? 'Till Date'
                                                          : moment(data?.pro_enddate).format('ll')}
                                                      </Typography>
                                                    </Breadcrumbs>
                                                  </Box>
                                                  {/* <Typography
                                                      variant="body2"
                                                      component="p"
                                                      sx={{
                                                        fontSize: styles.fontSize14,
                                                        color: 'rgba(0,0,0,0.5)',
                                                      }}
                                                    >
                                                      {data?.cityname && data?.statename
                                                        ? `${data?.cityname}, ${data?.statename}, ${data?.shortRegion}`
                                                        : 'Remote'}
                                                    </Typography> */}
                                                </Paper>
                                              </Box>
                                            </Stack>
                                          ))}
                                      </CardContent>
                                    </Card>
                                    {resumeCertificationDetails.length > 0 && (
                                      <Card sx={{ border: "1px solid #ddd", mt: 2 }}>
                                        <CardHeader
                                          title={
                                            <Typography
                                              paragraph
                                              style={{ fontSize: styles.fontSize18, fontWeight: 500, margin: 0 }}
                                            >
                                              Certifications
                                            </Typography>
                                          }
                                          sx={{ borderBottom: "1px solid #ddd" }}
                                        />
                                        <CardContent>
                                          <Stack direction="column">
                                            {resumeCertificationDetails.map((cer, index) => (
                                              <Typography key={index} paragraph sx={{ m: 0, fontSize: styles.fontSize14, }}>
                                                {`${index + 1}. `}
                                                {cer.cer_name}
                                              </Typography>
                                            ))}
                                          </Stack>
                                        </CardContent>
                                      </Card>
                                    )}
                                  </>
                                ) : (
                                  <></>
                                )}

                              </CardContent>
                            </Card>

                          </Box>
                        ) : null}
                      </Box>

                    </Grid>

                  </Grid>
                </DialogContent>

              </Dialog>
              <Box
                sx={{ flexShrink: 0, display: "flex", justifyContent: "end" }}
              >

                <Tooltip title={"Optimise Resume"}>
                  <Button
                    variant={interested ? "outlined" : "contained"}
                    color="primary"
                    size="small"
                    sx={{ marginRight: 1 }}
                    onClick={HandleOptimiseRedirection}
                  >
                    Optimise Resume
                  </Button>
                </Tooltip>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  sx={{ marginRight: 1 }}
                  onClick={HandleAdvancedOptimiseRedirection}
                >
                  Advanced Optimise Resume
                  <Tooltip title="Beta version" arrow>
                    <InfoOutlinedIcon
                      sx={{ ml: 0.5, fontSize: 16, cursor: 'help' }}
                    />
                  </Tooltip>
                </Button>

                <Tooltip title={"Interested"}>
                  <Button
                    variant={interested ? "outlined" : "contained"}
                    color="primary"
                    size="small"
                    sx={{ marginRight: 1 }}
                    // onClick={handleButtonClick}
                    onClick={handleClickOpen1}
                    disabled={
                      interestedJobIds?.length > 0 &&
                      interestedJobIds?.includes(parseInt(selectedJob?.id))
                    }
                  >
                    <ThumbUpAltOutlinedIcon />
                    {/* {interested ? "Not Interested" : "Interested"}&nbsp; */}
                    {/* {!interested && } */}
                  </Button>
                </Tooltip>
              </Box>
            </Stack>

            <Stack>

              <Grid item xs={12}>
                <Paper sx={{ boxShadow: "none", padding: "10px" }}>
                  {/* <Typography paragraph sx={{ fontWeight: 500 }}>
                    About the job
                  </Typography> */}
                  <div style={{ fontSize: "12px" }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ marginTop: 0, marginBottom: 0.5, fontWeight: "bold", lineHeight: 1.3 }}
                    >
                      Job Details:
                    </Typography>
                    {selectedJob?.job_description !== null &&
                      selectedJob?.job_description !== undefined &&
                      selectedJob?.job_description
                      ? !selectedJob?.job_description.includes("ahref") &&
                        !selectedJob?.job_description.includes("divclass") &&
                        !selectedJob?.job_description.includes("aclass") &&
                        !selectedJob?.job_description.includes("pclass") &&
                        !selectedJob?.job_description.includes("liclass")
                        ? parse(selectedJob?.job_description)
                        : selectedJob?.job_description.replace(/<[^>]+>/g, "")
                      : ""}
                  </div>
                </Paper>
              </Grid>
            </Stack>
              </Box>
            </Box>
          </Box>
        )}
      </Stack>
      <Snackbar
        open={toastOpen}
        autoHideDuration={6000}
        onClose={() => setToastOpen(false)}
      >
        <Alert onClose={() => setToastOpen(false)} severity="success">
          Successfully applied!
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default Jobdetailsview;
